import React, { useEffect, useState, useContext, createContext } from "react"
import Flatpickr from "react-flatpickr";

import {
    Col,
    Row,
    Card,
    CardBody,
    Container,
    Label,
    Input,
    InputGroup,
    Form,
    FormFeedback,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Button,
    Spinner,
    CardFooter
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik";

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import ModalContext from "../../contexts/ModalContext";
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang";
import moment from "moment";
import MyEditor from "components/MyEditor";
import UploadFileS3 from "components/UploadFileS3";
import InputAttachment from "components/Input/attachment/InputAttachment";
import PopupAttachment from "components/Input/attachment/PopupAttachment";
import UploadDesc from "components/UploadDesc";
import { ReactSortable } from 'react-sortablejs';
import Sortable from "sortablejs"
import Spinners from "components/Common/Spinner";
import { slugify } from "helpers/fn_helper";

// Services
import { SearchPageSetting, SavePageSetting, UpdatePageSetting } from "../../services/api/module/PageSetting.js"
import { UpdateContent, CreateContent, GetContentById } from "./services/Services";
import InputText from "components/Input/InputText";
import Error401 from "components/Error401";

const STATUS_OPTION = fn_helper.OPTIONS.STATUS

const _routeLink = `flagship-project`
const _pageName = `Flagship Project`
const _routePermission = `flagship-project:content-setting`

const FlagshipProjectContentSetting = ({
    pageView = "create",
    componentKey = "",
}) => {
    // POPUP
    const { mAlert } = useContext(ModalContext);

    // OTHER STATE
    const qParams = useParams()
    const qLang = _.upperCase(qParams?.lang) ?? 'TH'
    let qMainId = 1
    const navigate = useNavigate();

    const [waitSendData, setWaitSendData] = useState(false)
    const [contentLoading, setContentLoading] = useState(false)

    // ========== Form Validation ========== //
    const validationSchema = Yup.object({
        // contentPageName: Yup.string().required("Please Enter Site Name"),
        // titleCard: Yup.string().max(255).required("Please Enter Title Card"),
        // slug: Yup.string().max(255).required("Please Enter Slug"),

        // contentSeoTitle: Yup.string(),
        // contentSeoKeyword: Yup.string().max(1024),
        // contentSeoDescription: Yup.string().max(1024),

        contentUpdateDate: Yup.string().max(100).required("Please Select Written at"),
        contentStatus: Yup.string().max(100).required("Please Enter Display"),
        contentDetail: Yup.string().required("Please Enter Please Enter Deatil1"),
        contentDetail2: Yup.string().required("Please Enter Please Enter Deatil2"),
        // contentDetail2: Yup.string().required("Please Enter Please Enter Detail2"),

    })


    // LOCAL STATE FORM
    const [updatedValidationSchema, setUpdatedValidationSchema] = useState(validationSchema)

    const initialValues = {
        contentId: "",

        // Content
        // contentSitename: "",
        // slug: "",
        contentDetail: "",
        contentDetail2: "",
        bannerDesktop: {},
        bannerMobile: {},

        contentSeoTitle: "",
        contentSeoKeyword: "",
        contentSeoDescription: "",
        contentUpdateDate: moment().format('YYYY-MM-DD'),
        contentStatus: "active",

        slug: "",
        contentPageName: "",
        titleCard: "",
        regenTransTitle: "",
        regenTransDetail: "",
        regenTransIconTitle1: "",
        regenTransIconTitle2: "",
        regenTransIconTitle3: "",
        regenTransIconDetail1: "",
        regenTransIconDetail2: "",
        regenTransIconDetail3: "",
    }

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: updatedValidationSchema,
        onSubmit: values => {
            console.log("🚀 ~ ExecutivesPageCreate ~ values:", values)
            const payload = {
                id: qMainId,
                contentId: values.contentId ? values.contentId : undefined,
                langId: qLang,
                // titleCard: values.titleCard,
                contentDetail: values.contentDetail,
                contentDetail2: values.contentDetail2,

                contentUpdateDate: values.contentUpdateDate,
                contentStatus: values.contentStatus,

                attachmentData: {

                },

                contentAttachmentData: {
                    video: values.video,
                    // image2: values.image2,
                    // image3: values.image3,

                },

            };

            const pageSettingRoute = {
                contentPageName: values.contentPageName,
                slug: values.slug.replace(/-+$/, ''),
                componentKey: componentKey,
                contentDetail: values.contentDetail,
                attachmentData: {
                },
                contentAttachmentData: {
                    bannerDesktop: values.bannerDesktop,
                    bannerMobile: values.bannerMobile,
                },
                contentSeoTitle: values.contentSeoTitle,
                contentSeoKeyword: values.contentSeoKeyword,
                contentSeoDescription: values.contentSeoDescription,
                contentUpdateDate: values.contentUpdateDate,
                contentStatus: values.contentStatus,
            };

            console.log("🚀 ~ onSave ~ pageSettingRoute:", pageSettingRoute);

            setWaitSendData(true)

            console.log('qMainId', qMainId)
            console.log('pageView', pageView)
            if (pageView === "update" && qMainId > 0) {
                API.fetchUpdateContentPageSetting(payload, pageSettingRoute)
            } else {
                API.fetchCreateContent(payload, pageSettingRoute)
            }
        },
    })

    // const preFilInput = (resData = {}) => {
    //     // console.log("🚀 ~ preFilInput ~ resData:", resData)
    //     // resetForm(validation.values, initialValues)

    //     // ถ้าไม่หน่วงมันจะแย่งกันทำ
    //     // validation.setFieldValue("contentId", resData?.contentId ?? "")
    //     // validation.setFieldValue("contentSitename", resData?.contentSitename ?? "")
    //     // validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")
    //     // validation.setFieldValue("slug", resData?.slug ?? "")
    //     // validation.setFieldValue("bannerDesktop", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'banner_desktop') ?? "")
    //     // validation.setFieldValue("bannerMobile", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'banner_mobile') ?? "")
    //     // validation.setFieldValue("contentThumbnail", resData?.contentThumbnail ?? "")

    //     // validation.setFieldValue("contentSeoTitle", resData?.contentSeoTitle ?? "")
    //     // validation.setFieldValue("contentSeoKeyword", resData?.contentSeoKeyword ?? "")
    //     // validation.setFieldValue("contentSeoDescription", resData?.contentSeoDescription ?? "")
    //     // validation.setFieldValue("contentUpdateDate", resData?.contentUpdateDate ?? moment().format('YYYY-MM-DD'))
    //     // validation.setFieldValue("contentStatus", resData?.contentStatus ?? "active")

    // }

    const preFilInputPage = (resData = {}) => {
        console.log("🚀 ~ preFilInputPage ~ resData:", resData)
        // resetForm(validation.values, initialValues)
        validation.setFieldValue("contentId", resData?.contentId ?? "")

        validation.setFieldValue("contentPageName", resData?.contentPageName ?? "")
        validation.setFieldValue("slug", resData?.slug ?? "")
        // validation.setFieldValue("bannerDesktop", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'banner_desktop') ?? "")
        // validation.setFieldValue("bannerMobile", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'banner_mobile') ?? "")

        validation.setFieldValue("contentSeoTitle", resData?.contentSeoTitle ?? "")
        validation.setFieldValue("contentSeoKeyword", resData?.contentSeoKeyword ?? "")
        validation.setFieldValue("contentSeoDescription", resData?.contentSeoDescription ?? "")

        validation.setFieldValue("contentUpdateDate", resData?.contentUpdateDate ?? moment().format('YYYY-MM-DD'))
        validation.setFieldValue("contentStatus", resData?.contentStatus ?? "active")
    }

    const preFilInput = (resData = {}) => {
        console.log("🚀 ~ preFilInput ~ resData:", resData)
        // resetForm(validation.values, initialValues)

        // ถ้าไม่หน่วงมันจะแย่งกันทำ
        // validation.setFieldValue("contentId", resData?.contentId ?? "")
        // validation.setFieldValue("contentSitename", resData?.contentSitename ?? "")
        // validation.setFieldValue("slug", resData?.slug ?? "")
        // validation.setFieldValue("contentHeadline", resData?.contentHeadline ?? "")
        // validation.setFieldValue("titleCard", resData?.titleCard ?? "")
        validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")
        validation.setFieldValue("contentDetail2", resData?.contentDetail2 ?? "")

        validation.setFieldValue("video", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'video') ?? "")
        // validation.setFieldValue("image2", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'image2') ?? "")
        // validation.setFieldValue("image3", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'image3') ?? "")
        // validation.setFieldValue("image_card1", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'image_card1') ?? "")
        // validation.setFieldValue("image_card2", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'image_card2') ?? "")
        // validation.setFieldValue("image_card3", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'image_card3') ?? "")


        validation.setFieldValue(
            "contentUpdateDate",
            resData?.contentUpdateDate ?? moment().format("YYYY-MM-DD")
        )
        validation.setFieldValue(
            "contentStatus",
            resData?.contentStatus ?? "active"
        )

        // validation.setFieldValue("contentPageName", resData?.pageSettingRoute?.contentPageName ?? "")
        // validation.setFieldValue("slug", resData?.pageSettingRoute?.slug ?? "")
    }

    const API = {
        fetchGetContentPageSetting: async componentKey => {
            try {
                const response = await SearchPageSetting(componentKey, {
                    lang: qLang,
                })
                const resData = response.data
                if (resData.status == 200) {
                    preFilInputPage(resData.data)
                }
            } catch (err) {
                console.log("err ", err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong 001",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setContentLoading(false)
            }
        },

        fetchGetContentById: async payload => {
            try {
                const response = await GetContentById({
                    id: payload.id,
                    lang: qLang,
                })
                const resData = response.data
                if (resData.status == 200) {
                    preFilInput(resData.data)
                }
            } catch (err) {
                console.log("err ", err)
                qMainId = 0;

                // mAlert.info({
                //     title: "Alert",
                //     subTitle: "Something went wrong 001",
                //     content: "",
                //     onClose: () => {
                //         //  alert("onClose")
                //     },
                // })
            } finally {
                setContentLoading(false)
            }
        },
        fetchCreateContent: async (payload, pageSettingRoute) => {
            try {
                const response = await CreateContent({ data: payload, lang: qLang })
                const resData = response.data
                if (resData.status == 201) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Created Data Success",
                        content: "",
                        onClose: () => {
                            // navigate(`/${_routeLink}/${qLang}/edit`)
                            window.location.reload()
                        },
                    })
                }
            } catch (e) {
                console.log(e)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        },
        fetchUpdateContentPageSetting: async (payload, pageSettingRoute) => {
            try {
                const response = await UpdateContent({ data: payload, id: payload.id, lang: qLang })
                const resData = response.data
                if (resData.error && resData.status == 406) {
                    response = await CreateContent({ data: payload, lang: qLang })
                    resData = response.data
                    if (resData.status == 201) {
                        mAlert.info({
                            title: "Alert",
                            subTitle: "Update Data Success",
                            content: "",
                            onClose: () => {
                                // navigate(`/${_routeLink}/page/${qLang}/edit`)
                                window.location.reload()
                            },
                        })
                    }
                } else if (resData.status == 202) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Update Data Success",
                        content: "",
                        onClose: () => {
                            // navigate(`/${_routeLink}/page/${qLang}/edit`)
                            // window.location.reload()
                        },
                    })
                }
            }
            catch (err) {
                console.log('err ', err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        }
    }

    // กรณี Edit
    useEffect(() => {
        if (["update", "view"].includes(pageView)) {
            const payload = { id: qMainId }
            setContentLoading(true)

            API.fetchGetContentById(payload)
            // API.fetchGetContentPageSetting(componentKey)
        }
    }, [qLang])

    const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
    document.title = `${_pageName} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

    const itemStyle = {
        padding: '10px',
        border: '1px solid black',
        margin: '5px',
        borderRadius: '8px',
        background: '#f9f9f9',
        transition: 'transform 0.2s ease, background-color 0.3s ease',
    };

    const mapValues = (list = []) => list.map(item => {
        const newObj = {
            attachmentId: item.attachmentId,
            sequence: item.sequence
        }
        return newObj
    })

    if (!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
        return <Error401 />
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={`${PAGE_VIEW} Page Settings`}
                        breadcrumbItems={[
                            { title: "Page Settings", link: "" },
                            { title: PAGE_VIEW },
                        ]}
                    />

                    {/* Render Form */}
                    {
                        contentLoading
                            ? <Spinners setLoading={setContentLoading} />
                            :
                            <Row>
                                <Col className="col-12">
                                    <FormikProvider value={validation}>
                                        <Form
                                            className="form-horizontal"
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                        >
                                            <Row>
                                                <Col className="col-8">
                                                    <Card>
                                                        <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                                            <i className='bx bx-cube-alt'></i> Information Box
                                                        </h5>
                                                        <CardBody>
                                                            <Row>

                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="contentDetail"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Detail 1
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <MyEditor
                                                                            id="contentDetail"
                                                                            placeholder=""
                                                                            name="contentDetail"
                                                                            onChange={(e, editor) => {
                                                                                const data = editor.getData()
                                                                                validation.setFieldValue(
                                                                                    "contentDetail",
                                                                                    data
                                                                                )
                                                                                console.log({ e, editor, data })
                                                                            }}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.contentDetail}
                                                                            invalid={
                                                                                validation.touched.contentDetail &&
                                                                                    validation.errors.contentDetail
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            disabled={pageView === "view"}
                                                                        />
                                                                        {validation.touched.contentDetail &&
                                                                            validation.errors.contentDetail && (
                                                                                <FormFeedback type="invalid">
                                                                                    {validation.errors.contentDetail}
                                                                                </FormFeedback>
                                                                            )}
                                                                    </div>
                                                                    <hr />
                                                                </Col>

                                                                <Col className="col-12 mb-3">
                                                                    <div className="col-md-12">
                                                                        <PopupAttachment
                                                                            typeUpload="VideoMP4"
                                                                            upload="Video"
                                                                            prefixName="page-vdo"
                                                                            label="VDO MP4"
                                                                            required={false}
                                                                            description="description"
                                                                            value={validation.values.video}
                                                                            onChange={(value = {}, index) => {
                                                                                console.log("🚀 onChange ~ value:", value)
                                                                                console.log("🚀 onChange ~ index:", index)
                                                                                validation.setFieldValue('video', value)
                                                                            }}
                                                                            onRemove={(index) => {
                                                                                console.log("🚀 onChange ~ index:", index)
                                                                                validation.setFieldValue('video', {})
                                                                            }}
                                                                        />
                                                                        {validation.touched.video && validation.errors.video && (
                                                                            <div type="invalid" className="invalid-feedback d-block">
                                                                                {validation.errors.video}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <hr />
                                                                </Col>

                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="contentDetail2"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Detail 2
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <MyEditor
                                                                            id="contentDetail2"
                                                                            placeholder=""
                                                                            name="contentDetail2"
                                                                            onChange={(e, editor) => {
                                                                                const data = editor.getData()
                                                                                validation.setFieldValue(
                                                                                    "contentDetail2",
                                                                                    data
                                                                                )
                                                                                console.log({ e, editor, data })
                                                                            }}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.contentDetail2}
                                                                            invalid={
                                                                                validation.touched.contentDetail2 &&
                                                                                    validation.errors.contentDetail2
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            disabled={pageView === "view"}
                                                                        />
                                                                        {validation.touched.contentDetail2 &&
                                                                            validation.errors.contentDetail2 && (
                                                                                <FormFeedback type="invalid">
                                                                                    {validation.errors.contentDetail2}
                                                                                </FormFeedback>
                                                                            )}
                                                                    </div>
                                                                    <hr />
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                                <Col className="col-4">
                                                    <Card outline color="primary" className="border sticky-element">
                                                        <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                                                            <i className='bx bx-check'></i> Tools Box
                                                        </h5>
                                                        <CardBody>
                                                            <Row>
                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Switch Language
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <InputLang widthfull pageView={pageView} forceRoute={false} />
                                                                    </div>
                                                                </Col>
                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Written at
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <InputGroup>
                                                                            <Flatpickr
                                                                                className="form-control d-block"
                                                                                options={{
                                                                                    dateFormat: 'd/m/Y', // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                                                                }}
                                                                                value={validation.values.contentUpdateDate ? moment(validation.values.contentUpdateDate, 'YYYY-MM-DD').toDate() : null}
                                                                                disabled={true}
                                                                            />
                                                                            <div className="input-group-append">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-outline-secondary docs-datepicker-trigger"
                                                                                    disabled
                                                                                >
                                                                                    <i className="fa fa-calendar" aria-hidden="true" />
                                                                                </button>
                                                                            </div>
                                                                        </InputGroup>
                                                                        {
                                                                            (validation.touched.contentUpdateDate && validation.errors.contentUpdateDate) && (
                                                                                <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentUpdateDate}</div>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </Col>
                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Display
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <Select
                                                                            placeholder="Select Status"
                                                                            value={fn_helper.FNFORM.getObjectValue(STATUS_OPTION, `${validation.values.contentStatus}`)}
                                                                            onChange={(value) => validation.setFieldValue("contentStatus", value.id)}
                                                                            getOptionValue={(option) => option.id}
                                                                            getOptionLabel={(option) => option.name}
                                                                            options={STATUS_OPTION}
                                                                            className={`select2-selection ${validation.touched.contentStatus && validation.errors.contentStatus ? "input-err" : ""}`}
                                                                            isDisabled={pageView === "view"}
                                                                        />
                                                                        {
                                                                            (validation.touched.contentStatus && validation.errors.contentStatus) && (
                                                                                <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentStatus}</div>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                        <CardFooter>
                                                            <Row>
                                                                {/* <Col className="text-start">
                                                                    <Button color="danger" className="btn btn-danger" onClick={() => navigate(`/business-feature-story/${qLang}`)}>Back</Button>
                                                                </Col> */}
                                                                <Col className="text-end">
                                                                    {pageView !== 'view' && (
                                                                        <Button type="submit" className="btn btn-success">
                                                                            Save  {waitSendData ? <Spinner size="sm" color="light" /> : null}
                                                                        </Button>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </CardFooter>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </FormikProvider>
                                </Col>
                            </Row>
                    }
                </Container>
            </div>
        </React.Fragment>
    )
}

// QuestionaireCategory.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(FlagshipProjectContentSetting)
